module.exports = ".single-condition-row {\n  margin-top: 8px;\n  margin-bottom: 8px; }\n  .single-condition-row .form-group {\n    margin-bottom: 0; }\n  .single-condition-row .item {\n    margin-top: 0; }\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/modules/sessions/registration-form/edit-registration-field-single-condition/edit-registration-field-single-condition.component.scss
// module id = ./src/app/modules/sessions/registration-form/edit-registration-field-single-condition/edit-registration-field-single-condition.component.scss
// module chunks = main